// import { Intersections } from "../hooks/Intersections";
import React from "react";

type SectionProps = {
  children: React.ReactNode;
  className?: string;
  bg?: "white" | "rose" | "blue" | "green" | "brown";
  noFlex?: boolean;
};

const bgColorMap: Record<string, string> = {
  white: "bg-white",
  rose: "bg-[#FAF8F6]",      // already soft, keep as-is
  blue: "bg-[#f2f7f8]",      // softer than #EDF6F9
  green: "bg-[#eff8f4]",     // softer than #E6F6F0
  brown: "bg-[#FBF8F5]",     // lighter, elegant cream-tan
  sand: "bg-[#f7f2ec]"
};

export const Section = ({
  children,
  className = "",
  bg = "white",
  noFlex = false,
}: SectionProps) => {
  const defaultPadding = "pt-[72px] lg:pt-[64px] pb-[72px] lg:pb-[64px]";
  const sectionClasses = [
    defaultPadding,
    bgColorMap[bg],
    className, // ← Let user override it!
  ].join(" ");

  const containerClasses = `container mx-auto ${!noFlex ? "flex flex-col lg:flex-row items-start gap-8" : ""}`;

  return (
    <section className={sectionClasses}>
      <div className={containerClasses}>{children}</div>
    </section>
  );
};